import { Space, Typography } from 'antd';
import { RevxButton } from 'components/RevxButton';
import { TableColumnsType, RevxTable } from 'components/RevxTable';
import { ValidatingAddress } from 'domains/shippingDomain';
import { toUpper, toString } from 'lodash-es';
import { useTranslation } from 'react-i18next';

const { Text } = Typography;
type Props = {
  suggestions: ValidatingAddress[];
  address: ValidatingAddress;
  onApply: (item: ValidatingAddress) => void;
};
export const AddressSuggestionsTable = ({
  suggestions,
  onApply,
  address,
}: Props) => {
  const { t } = useTranslation();
  const columns: TableColumnsType<ValidatingAddress> = [
    {
      title: t('platform.shipping.form.addressLine'),
      dataIndex: 'addressLine',
      key: 'addressLine',
      render: (text, record) => {
        if (text === address.addressLine) {
          return text;
        } else {
          return (
            <Space>
              <Text delete>{address.addressLine}</Text>
              <span>{text}</span>
            </Space>
          );
        }
      },
    },
    {
      title: t('platform.shipping.form.postalCode'),
      dataIndex: 'postalCode',
      key: 'postalCode',
      render: (text, record) => {
        if (text === address.postalCode) {
          return text;
        } else {
          return (
            <Space>
              <Text delete>{address.postalCode}</Text>
              <span>{text}</span>
            </Space>
          );
        }
      },
    },
    {
      title: t('platform.shipping.form.countryCode'),
      dataIndex: 'countryCode',
      key: 'countryCode',
      render: (text, record) => {
        if (toUpper(text) === toUpper(address.countryCode)) {
          return text;
        } else {
          return (
            <Space>
              <Text delete>{address.countryCode}</Text>
              <span>{text}</span>
            </Space>
          );
        }
      },
    },
    {
      title: t('platform.shipping.form.stateProvinceCode'),
      dataIndex: 'stateProvinceCode',
      key: 'stateProvinceCode',
      render: (text, record) => {
        if (toUpper(text) === toUpper(address.stateProvinceCode)) {
          return text;
        } else {
          return (
            <Space>
              <Text delete>{address.stateProvinceCode}</Text>
              <span>{text}</span>
            </Space>
          );
        }
      },
    },
    {
      title: t('platform.shipping.form.city'),
      dataIndex: 'city',
      key: 'city',
      render: (text, record) => {
        if (toUpper(text) === toUpper(address.city)) {
          return text;
        } else {
          return (
            <Space>
              <Text delete>{address.city}</Text>
              <span>{text}</span>
            </Space>
          );
        }
      },
    },
    {
      title: t('common.actions'),
      key: 'actions',
      fixed: 'right',
      width: 100,
      render: (text, record) => (
        <RevxButton
          type="link"
          key="view"
          size="small"
          onClick={() => onApply(record)}
        >
          {t('common.apply')}
        </RevxButton>
      ),
    },
  ];

  return (
    <RevxTable
      columns={columns}
      dataSource={suggestions}
      pagination={false}
      rowKey={(record) => toString(record)}
    />
  );
};
